export default __webpack_public_path__ + "static/media/method2.621a29c4.png";